module.exports = __webpack_public_path__ + "static/media/Gallery15.b2ceb1ab.jpg";